import { gql } from '@apollo/client';

export default gql`
  fragment InspectionFields on Inspection {
    id
    identifier
    dueDate
    doneAt
    canceledAt
    periodCycle
    periodNumber
    name
    number
    status
    result
    overdue
    incoming
    
  }
`;
